<!-- Body -->
<!-- News header -->
<div class="swapa-news-header">
    <h1>{{staticContent?.NewsPageTitle}}</h1>
    <div class="row justify-content-end align-items-center">
        <div class="col-12 col-md-auto">
            <label class="input-group d-flex align-items-center">
                <span class="input-group-prepend text-primary pr-2">
                    Filter by
                </span>
                <select required class="form-control d-inline-block"  name="dnFilterText"
                       #dnFilterText (change)="onFilterChange($event)">
                    <option value="0" selected>No filter</option>
                    <option *ngFor="let value of filterbyValues" value={{value}}>{{value}}</option>
                </select>
            </label>
        </div>
        <div class="col-12 col-md-auto">
            <label class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <div class="swapa-search"></div>
                    </span>
                </div>
                <input [(ngModel)]="searchText" type="text"
                       class="form-control"
                       name="txtSearch"
                       #txtSearch
                       (keydown.enter)="performTextSearch($event)"
                       placeholder="Search Articles" />
            </label>
        </div>
    </div>
</div>

<!-- News articles -->
<h3 *ngIf="isLoading && !newsArticles" [innerHTML]="staticContent?.loadingMessage"></h3>
<h3 *ngIf="newsArticles && newsArticles.TotalMatching>0" [innerHTML]="newsArticles.ResultFoundMessage"></h3>
<h3 *ngIf="newsArticles && newsArticles.TotalMatching==0" [innerHTML]="newsArticles.NoResultMessage"></h3>
<div class="swapa-body" *ngIf="newsArticles">
    <article class="row" *ngFor="let article of newsArticles.Items">
        <div class="col-12 col-md-4 mb-2 mb-md-0">
            <img class="cover"
                 src="{{article.ImagePath}}"
                 alt=""
                 width="100%"
                 height="200" />
        </div>
        <div class="col-12 col-md">
            <a href="{{article.Url}}" [attr.target]="article.IsMedia ? '_blank' : '_self'">
                <h3 class="text-uppercase" [innerHTML]="article.NewsTitle">
                </h3>
                {{article.NewsDate}}
            </a>
            <ng-container *ngIf="article.ArticleTypeTagText">
                | <a href="{{article.ArticleTypeTagUrl}}">{{article.ArticleTypeTagText}}</a><span *ngIf="article.Categories.length > 0">, </span>
            </ng-container>
            <ng-container *ngFor="let category of article.Categories; let first = first; let last = last;">
                <span *ngIf="first && !article.ArticleTypeTagText"> | </span> <a href="{{staticContent?.FilterUrl}}{{category.UrlFriendlyName}}">{{category.Description}}</a><span *ngIf="!last">, </span>
            </ng-container>
            <p [innerHTML]="article.NewsSummary">
            </p>
        </div>
    </article>
</div>

<!-- News pagination -->
<div *ngIf="newsArticles && newsArticles.Items?.length>0 && newsArticles.TotalMatching > pageSize" class="row justify-content-center justify-content-md-between align-items-center">
    <div class="col-12 col-md-5 text-left">
        <span>Showing {{endIndex}} of {{ newsArticles.TotalMatching }} results</span>
    </div>
    <div class="col-12 col-md-5 text-center">
        <ngb-pagination [collectionSize]="newsArticles.TotalMatching" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
        </ngb-pagination>
    </div>
    <div class="col-12 col-md-2 text-right">
        <p *ngIf="isLoading">Please wait...</p>
    </div>
</div>
<div *ngIf="newsArticles && newsArticles.Items?.length>0" class="swapa-top-tocshortcut text-right text-nonselectable">
    <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#topofbody"> ↑ Back To Top </a>
</div>